import React from "react";
import { Link, Outlet } from "react-router-dom";
import { Container, Navbar, Nav, NavDropdown } from "react-bootstrap";

// export default function HomeNavbar() {
//   return (
//       <Navbar bg="light">
//         <Container>
//           <Navbar.Brand as={Link} to="/">CrosseyeVR</Navbar.Brand>
//         </Container>
//       </Navbar>
//   );
// }

export default function HomeNavbar() {
    return (
        <Navbar collapseOnSelect expand="lg" bg="light" variant="light">
        <Container>
            <Navbar.Brand as={Link} to="/">CrosseyeVR</Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
                <Nav.Link href="#features">Features</Nav.Link>
                <Nav.Link href="#pricing">Pricing</Nav.Link>
                {/* <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">
                    Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">
                    Separated link
                </NavDropdown.Item>
                </NavDropdown> */}
            </Nav>
            <Nav>
                <Nav.Link as={Link} eventKey={2} to="/auth/login">
                Login
                </Nav.Link>
            </Nav>
            </Navbar.Collapse>
        </Container>
        </Navbar>
    );
}
